import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './home.css';

function Home() {
  useEffect(() => {
    document.title = 'Home | Varun Kaushal';
  }, []);

  return (
    <section className="main-content">
      <div className="content-section">
        <h2>Hi, I'm</h2>
        <h1 className="main-heading">Varun Kaushal</h1>
        <p className="body-text">
          I'm in my final year of BTech in Computer Science and Engineering at VIT University, Vellore, where I've been exploring everything from algorithms to architecture.
        </p>
        <p className="body-text">
          I've recently worked with .NET MVC and Core during an internship, and built a hands-on machine learning project using Python and Flask — combining real-world data with practical development.
        </p>
        <p className="body-text">
          I'm all in on the cloud revolution too, with certifications in AWS Cloud Practitioner and Microsoft Azure AI Fundamentals. I'm always looking to build things that are scalable, reliable, and cloud-ready.
        </p>
      </div>

      <div className="content-section">
        <img
          src={`${process.env.PUBLIC_URL}/images/VKphoto.jpeg`}
          alt="Varun Kaushal"
          className="responsive-image"
        />
        <p className="contact-info">
          <FontAwesomeIcon icon={faEnvelope} />
          <a href="mailto:kaushalvarunkv@gmail.com" className="contact-link">
            kaushalvarunkv@gmail.com
          </a>
        </p>
        <p className="contact-info">
          <FontAwesomeIcon icon={faLinkedin} />
          <a
            href="https://www.linkedin.com/in/kaushal-varun/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            Varun Kaushal
          </a>
        </p>
      </div>
    </section>
  );
}

export default Home;
